// extracted by mini-css-extract-plugin
export default {"main":"FormWrapper_main__MSUCw"};